"use client";

import { useAgentNavigation, useIsUnifiedChatEnabled } from "../hooks";
import { AgentDock } from "./dock/AgentDock";
import type { ReactNode } from "react";

// The wrapper renders whether or not the flag is on, so its client load never remounts the page.
export const UnifiedChatShell = ({ children }: { children: ReactNode }) => {
  const isUnifiedChatEnabled = useIsUnifiedChatEnabled();
  useAgentNavigation();
  return (
    <div className="flex min-h-svh w-full min-w-0">
      <div className="flex min-w-0 flex-1">{children}</div>
      {isUnifiedChatEnabled && <AgentDock />}
    </div>
  );
};
